import React from 'react'
import atoms from '../../atoms'
import { WarrantyProduct, WarrantyProps } from './interface'
import molecules from '../../molecules'
const {WarrantyCard} = molecules
const { Button, Input } = atoms

const Index: React.FC<WarrantyProps> = ({ warrantyProductData, warrantyProductList, handleChange,searchDetail,handleWarrantyClaim }) => {

    return (
        <>
            <div className="row">
                <div className='col-4 pe-0'>
                    <Input
                        type={'text'}
                        className="input-height input-container-height"
                        value={searchDetail?.invoice_number}
                        placeholder={window?.innerWidth<768 ? "Invoice No." : "Enter Invoice Number"}
                        onChange={(e: any) => {
                            handleChange("invoice_number", e.target.value)
                        }} />
                </div>
                <div className='col-4 pe-0'>
                    <Input
                        type='text'
                        className="input-height input-container-height"
                        placeholder={window?.innerWidth<768 ? "Modal No." : "Enter Modal Number"}
                        onChange={(e: any) => {
                            handleChange("modal_number", e.target.value.replace(/\s/g, ''))
                        }} />
                </div>
                <div className='col-4'>
                    <Button onClick={()=>warrantyProductList()}>Search</Button>
                </div>
            </div>

            <div className="row">
                <div className="col mt-3">
                    {
                        warrantyProductData?.length > 0 ? (
                            warrantyProductData.map((product: WarrantyProduct, index: number) => (
                                (
                                    <div className="row">
                                        <div className="col mt-4">
                                            <WarrantyCard
                                            product={product}
                                            handleWarrantyClaim={(id:string)=>handleWarrantyClaim(id)}
                                            />
                                        </div>
                                    </div>
                                )
                            ))
                        ) : (
                            <div className='justify-content-center d-flex secondary-color'>
                                There are no records to display
                            </div>
                        )
                    }
                </div>
            </div>
        </>
    )
}

export default Index